import { render, staticRenderFns } from "./SectionResultatPrelevement.vue?vue&type=template&id=3506f722&scoped=true&"
import script from "./SectionResultatPrelevement.vue?vue&type=script&lang=js&"
export * from "./SectionResultatPrelevement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506f722",
  null
  
)

export default component.exports